const FloatToFixed = (value) => {
    if (!value) return ''
    let newNumber = parseFloat(value).toFixed(2)
    return newNumber
}

const MoneyFormat = (value) => {
    if (!value) return ''
    // value = Math.abs(value)
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

const AbsolutNumber = (value) => {
    return Math.abs(value)    
}

export default ({
    FloatToFixed, 
    MoneyFormat,
    AbsolutNumber
})
